import { CheckIcon, UpdateIcon } from '@radix-ui/react-icons';
import { useState } from 'react';
import api from '../../lib/api';
import { Button } from '../ui/button';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from '../ui/dialog';
import { DropdownMenuItem } from '../ui/dropdown-menu';
import { toast } from '../ui/use-toast';

const MarkRegistrationPaidDialog = ({ driverId, competitionId, fetchCompetition, fetchParticipants }) => {

    const [isLoading, setIsLoading] = useState(false);

    const handlePaid = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const response = await api.post('https://skhrf-api.cmdigital.se/v1/registrations/mark-paid', {
                driverId: driverId,
                competitionId: competitionId,
            });

            fetchCompetition();
            fetchParticipants();

            toast({
                title: 'Betalning registrerad.',
                description: 'Förares ekipage markerade som betalda.',
            });
        } catch (error) {
            toast({
                variant: 'destructive',
                title: 'Något gick fel.',
                description: error.response?.data?.error || 'Okänt fel',
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Dialog>
            <DropdownMenuItem className="w-full" onSelect={(event) => event.preventDefault()}>
                <DialogTrigger className="flex items-center w-full">
                    <CheckIcon className="mr-3" />
                    Markera som betald
                </DialogTrigger>
            </DropdownMenuItem>
            <DialogContent className="flex flex-col gap-6">
                <DialogHeader className="text-left">
                    <DialogTitle>Markera som betald</DialogTitle>
                    <DialogDescription>
                        Observera att denna åtgärd inte går att ångra.
                    </DialogDescription>
                </DialogHeader>
                <div className="grid grid-cols-2 gap-3">
                    <DialogClose asChild>
                        <Button type="button" variant="secondary">
                            Avbryt
                        </Button>
                    </DialogClose>
                    <Button onClick={handlePaid} disabled={isLoading}>
                        {isLoading ? <UpdateIcon className="loader-spinner" /> : 'Markera som betald'}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default MarkRegistrationPaidDialog;
